// Client side of the compromised-device flow.
//
// When api() sees `X-Compromise-Signal: true` on any response (it rides a 401
// from the server's compromise gate), this:
//   1. drops the in-memory access token,
//   2. hard-navigates to /login — a full reload guarantees a clean slate.
//
// The marketing site holds no encrypted offline store, so there is no local
// data to wipe; the server has already revoked the session chain. Guarded so
// concurrent signalled responses trigger exactly one redirect.

import { setAccessToken } from './auth';

let wiping = false;

export function handleCompromiseSignal(): void {
  if (wiping) return;
  wiping = true;
  setAccessToken(null);
  redirectToLogin();
}

// resetCompromiseGuard is for tests only — the guard is a module singleton.
export function resetCompromiseGuard(): void {
  wiping = false;
}

function redirectToLogin(): void {
  // Hard navigation (matching auth.ts startOAuth), not an SPA route change: a
  // full document reload guarantees no in-memory state or timers survive the
  // compromise.
  if (typeof window !== 'undefined' && window.location) {
    window.location.assign('/login');
  }
}
